export default function getTheme(){
  const theme = {
    background: "white",
    headerBgColor: "linear-gradient(0deg, rgba(77,25,208,1) 0%, rgba(128,0,128,1) 64%);",
    headerPadding: "10px",
    headerFontColor: "white",
    headerFontSize: "20px",
    botBubbleColor: "#dee0f1",
    botFontColor: "#312a2d",
    userBubbleColor: "#f5e0f2",
    userFontColor: "#312a2d",
    
  };
  return theme;
}